import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    employeeTransfers: [],
    transfer: {},
    administrations: [],
    departments: [],
    units: [],
    totalItems:0,
};

const getters = {
    index: state => employeeTransferId => state.employeeTransfers.findIndex(i => i.employeeTransferId === employeeTransferId)
};

const mutations = {
    setEmployeeTransfers: (state, r) => (state.employeeTransfers = r),
    setTotalItems: (state, totalItems) => (state.totalItems = totalItems),
    add: (state, r) => state.employeeTransfers.unshift(r),
    delete: (state, index) => state.employeeTransfers.splice(index, 1),
    setTransfer: (state, r) => (state.transfer = r),
    edit: (state, { index, transfer }) => state.employeeTransfers.splice(index, 1, transfer),
    approve: (state, index) => state.employeeTransfers[index].status = status.approved,
    reject: (state, index) => state.employeeTransfers[index].status = status.rejected,
    setAdministrations: (state, administrations) => (state.administrations = administrations),
    setDepartments: (state, departments) => (state.departments = departments),
    setUnits: (state, units) => (state.units = units),

};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.employeeTransfers.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployeeTransfers", response.data.employeeTransfers);
            commit("setTotalItems", response.data.totalItems);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            let formData = new FormData()
            console.log(payload.remarks);
            console.log(payload);
            formData.append("transferTypeId", payload.transferTypeId);
            formData.append("toAdministrationId", payload.toAdministrationId);
            formData.append("toDepartmentId", payload.toDepartmentId);
            formData.append("toUnitId", payload.toUnitId);
            formData.append("employeeId", payload.employeeId);
            formData.append("transferDate", payload.transferDate);
            formData.append("transferReasonId", payload.transferReasonId);
            formData.append("remarks", payload.remarks);
            formData.append("attachmentFile", payload.attachmentFile);
            
            console.log(formData);

            startLoading()
            const response = await dataService.employeeTransfers.add(formData);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.newTrans);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeeTransfers.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },

    async getDetails({ commit }, id) {
        try {
            commit("setTransfer", {});
            startLoading()
            const response = await dataService.employeeTransfers.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setTransfer", response.data.transfer);
         
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.employeeTransfers.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.transfer);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            let formData = new FormData()
            formData.append("transferDate", payload.transferDate);
            formData.append("transferReasonId", payload.transferReasonId);
            formData.append("remarks", payload.remarks);
            formData.append("attachmentFile", payload.attachmentFile);
         
          
            startLoading()
            const response = await dataService.employeeTransfers.edit(id, formData);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
         
            const index = getters.index(id);
            commit("edit", { index, transfer: response.data.transfer });

          /*  return Promise.resolve()*/
        } catch (error) {
            console.log(error)
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },

    async approve({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeeTransfers.approve(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("approve", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async reject({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeeTransfers.reject(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("reject", index);
        } catch (error) {

            stopLoading()
            catchHandler(error);
        }
    },

    async getAdministrations({ commit }) {
        try {
            const response = await dataService.lookups.getAdministrations();

            const administrations = response.data.administrations;
            commit("setAdministrations", administrations);
        } catch (error) {
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },

    async getDepartments({ commit }, administrationId) {
        try {
            const response = await dataService.lookups.getDepartments(administrationId);

            const departments = response.data.departments;
            commit("setDepartments", departments);
        } catch (error) {
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getUnitsById({ commit }, { id, typeId }) {
        try {
            const response = await dataService.lookups.getUnitsById(id, typeId);

            const units = response.data.units;
            commit("setUnits", units);
        } catch (error) {
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
